module.exports = __webpack_public_path__ + "static/media/image_14.7fbeb20e.jpg";